// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_MKQ","cls2":"PodcastLibraryCarouselAd-cls2_-vz PodcastLibraryCarouselAd-cls1_MKQ"};